<template>
	<div class="phantom-container">
		<notifications classes="master-notifications" position="top left" group="default" />
		<router-view></router-view>
		<loader />
	</div>
</template>

<script>
import loader from '@/common/components/loader'
export default {
	name: 'app',
	components: {
		loader
	},
	mounted () {
		console.log('[Patrimoffice] v1.3.0')
	},
	watch: {
		$route (to, from) {
			this.$ga.page(to.fullPath)
		}
	}
}
</script>

<style lang="scss">
	@import '~@/common/assets/sass/common.scss';
	@import '~@/assets/sass/master.scss';
</style>



// WEBPACK FOOTER //
// App.vue?707e85a6